/** @jsx jsx */
import { jsx } from '@emotion/core'
import _ from 'lodash'
import dayjs from 'dayjs'
import React from 'react'
import { observer } from 'mobx-react'
import GuideCharacter from '@assets/images/bg/character/first-bet-characte-02.png'
import { CharacterDialog } from '@views/Popup/Dialog/CharacterDialog'
import useRootStore from '@store/useRootStore'
import * as Utils from '@utils/utils'


export const TransferApplicationCompletedInfo: React.FC = observer(() => {
  const { globalStore } = useRootStore()
  const accountTransferOpt = globalStore.getAccountTransferOptions()

  let toDate = ''
  if (!_.isEmpty(accountTransferOpt.period.to)) {
    const toInst = dayjs(accountTransferOpt.period.to)
    toDate = `${toInst.format('YYYY.M.D')}(${Utils.getDayOfWeeks(accountTransferOpt.period.to)})`
  }

  const img = <img src={GuideCharacter} alt="캐릭터" className="guide-character" loading="lazy"/>
  const title = (
    <p className="guide-txt big">
      계정 이관 신청 완료
    </p>
  )
  const body = (
    <div className="guide-box small ">
      계정 이관 신청을 해주셔서 감사합니다.<br/><br/>
      <span className="point-color--orange--modal">{`${toDate} 정기점검`}</span><br/>
      계정 이관이 진행될 예정이며,<br/>
      이관 전까진 정상적으로 계정이 이용 가능합니다.<br/><br/>

      이관 완료 이후부터는 선택한 계정으로<br/>
      점속 시 카카오 게임 데이터 그대로 이용 가능합니다.
    </div>
  )

  return (<CharacterDialog characterImg={img} title={title} body={body}/>)
})
